/** Manual USD → VND rate for catalog display and VN payment conversion. */
export const USD_TO_VND = 25981.5
